import en from './en'

const resources = {
  en,
} as const

export { resources }
